import React from 'react';
import { profileData } from '../data/mock';
import { Card, CardContent } from './ui/card';

const About = () => {
  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-8 text-center">
          About Me
        </h2>
        
        <Card className="border-border shadow-lg">
          <CardContent className="p-6 sm:p-8">
            <p className="text-sm sm:text-base text-muted-foreground leading-7">
              {profileData.bio}
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default About;
